<template>
  <div class="mt-5 container-padding h-10 [&>*]:h-full [&>*>*]:h-full [&>*>*>input]:h-full">
    <slot />
  </div>
</template>
<script setup lang="ts">
</script>
